// extracted by mini-css-extract-plugin
export default {"video":"Videos_video__z+AXX","qmeta":"Videos_qmeta__++AZd"};